import { UPDATE_ORG_AGENCIES } from '../actions/agencies';

const initialState = null;

const orgAgencies = (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_ORG_AGENCIES:
            return action.agencies;
        default:
            return state;
    }
};

export default orgAgencies;
